import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('parent');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        // strict mode causes issues with the web assembly
        //   <React.StrictMode>
        //     <App />
        //   </React.StrictMode>
        <App />
    );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
